export const polygonProps = () => {
  const baseFull = (alpha: number) => `rgba(0, 123, 255, ${alpha})`;
  const baseEmpty = (alpha: number) => `rgba(239, 95, 0, ${alpha})`;
  const baseSelected = (alpha: number) => `rgba(248, 207, 0, ${alpha})`;

  const stroke = () => {
    return {
      orange: () => baseEmpty(1),
      blue: () => baseFull(1),
      yellow: () => baseSelected(1),
    };
  };

  const fill = (alpha = 0.25) => {
    return {
      orange: () => baseEmpty(alpha),
      blue: () => baseFull(alpha),
      yellow: () => baseSelected(alpha),
    };
  };

  const bold = () => 4;
  const thin = () => 1;

  return {
    stroke,
    fill,
    bold,
    thin,
  };
};
